import setTransform from '../utils/setTransform'
import Observable from '../utils/Observable'
import getBcr, { refreshBcrs } from '../utils/getBcr'
import {headerHeight, windowWidth} from '../dimensions'

const moveTable = table => {
  const setTableTransform = setTransform(table)
  const setLegendTransform = setTransform($(table).find('tr > :not(:first-child)'))
  return scrollX => {
    //setTableTransform(`translate3d(${-scrollX}px,0,0)`)
    setLegendTransform(`translate3d(${-scrollX}px,0,0)`)
  }
}

const moveTableAnimated = table => {
  let obj = { foo: 0 }
  const moveThisTable = moveTable(table)
  return scrollX => {
    $(obj).stop().animate({ foo: scrollX }, {
      step: moveThisTable
    })
  }
}

const initDimensions = container => {
  const table = container.find('table')
  const columnWidth = Observable.combine(
    table.find('tr').eq(0).children().toArray().map(getBcr), 
    bcrs => Math.max.apply(this, bcrs.map(x => x.width))
  )
  //const columnCount = new Observable(table.find('tr').eq(0).children().length - 1)
  const visibleColCount = Observable.combine([
    columnWidth, 
    getBcr(container.find('.container'))
  ], ([columnWidth, containerBcr]) => 
    Math.floor(containerBcr.width / columnWidth)
  )

  return { columnWidth, visibleColCount }
}

const initHeader = container => {
  const table = container.find('table')

  const header = table.find('tr').eq(0)
  const headerCopy = header.clone()
    .wrap('<thead />').parent()
    .wrap('<table class="table" />').parent()
    .wrap('<div class="container" />').parent()
    .wrap('<div class="xr-header-clone" />').parent()
  headerCopy.appendTo(container)

  const showCopy = Observable.combine([getBcr(table), getBcr(header), getBcr(headerCopy), headerHeight], ([tableBcr, thBcr, copyBcr, headerHeight]) => {

    if (tableBcr.bottom < copyBcr.height + headerHeight) return false
    if (tableBcr.top - headerHeight - copyBcr.height > -thBcr.height) return false
    return true
  })

  showCopy.watch(x =>
    headerCopy.toggleClass('xr-header-clone--visible', x)
  )

  return {  }
}

const initClose = (container, dimensions) => {
  const table = container.find('table')

  const columnCount = table.eq(0).find('tr').eq(0).children().not('.fill').length - 1
  const columnVisible = new Observable(Array.apply(null, Array(columnCount)).map(x => true))
  columnVisible.watch(columnVisible => {
    columnVisible.forEach((visible, i) => {
      table.find(`tr > :nth-child(${i + 2})`).toggleClass('xr-hidden', !visible)
    })
  })

  const hideColumn = index => {
    let vis = [...columnVisible.get()]
    if (vis.filter(x => x).length <= 2) return
    vis[index] = false
    columnVisible.set(vis)
  }

  const visibleColumnCount = columnVisible.map(arr => arr.filter(x => x).length)

  table.not('.xr-header-clone table').find('thead th:not(.reset) > span').each(function (i) {
    if (i > 0)
      $(`<button class="button button--solid button--icon"><span class="glyphicons glyphicons-remove"></span></button>`).click(() => hideColumn(i - 1)).appendTo(this)
  })

  return {
    columnCount: visibleColumnCount,
    resetColumns: () => columnVisible.set(columnVisible.get().map(x => true)),
    canReset: visibleColumnCount.map(x => x != columnCount)
  }
}

const initScroll = (container, dimensions, columnCount) => {
  const table = container.find('table')
  const moveThisTable = moveTable(table)
  const moveThisTableAnimated = moveTableAnimated(table)

  const { columnWidth, visibleColCount } = dimensions
  const scrollMax = Observable.combine([visibleColCount, columnCount, windowWidth], ([visibleColCount, columnCount, windowWidth]) => {
    let result = columnCount - visibleColCount
    if (991 < windowWidth && windowWidth < 1740) {
      result++
    }
    return result
  })

  const currentIndex = new Observable(0, x =>
    Math.min(scrollMax.get(), Math.max(0, x))
  )
  scrollMax.watch(scrollMax => {
    if (currentIndex.get() > scrollMax) {
      currentIndex.set(scrollMax)
    }
  })

  const scrollX = Observable.combine(
    [columnWidth, currentIndex], 
    ([columnWidth, currentIndex]) => Math.max(0, columnWidth * currentIndex)
  ).watch(moveThisTableAnimated)

  return { 
    currentIndex, 
    canDoPrev: currentIndex.map(x => x > 0),
    canDoNext: Observable.combine([currentIndex, scrollMax], ([i, max]) => i < max),
  }
}

const addButtons = (container, scroll, dimensions) => {
  const controls = $(`<div class="xr-slider-controls" />`).insertBefore(container.not('.section > :first-child'))
  const btnPrev = $(`<div class="slick-prev" />`).appendTo(controls)
  const btnNext = $(`<div class="slick-next" />`).appendTo(controls)
  btnPrev.click(() => scroll.currentIndex.set(scroll.currentIndex.get() - 1))
  btnNext.click(() => scroll.currentIndex.set(scroll.currentIndex.get() + 1))
  scroll.canDoNext.watch(canDoNext => btnNext.toggleClass('slick-disabled', !canDoNext))
  scroll.canDoPrev.watch(canDoPrev => btnPrev.toggleClass('slick-disabled', !canDoPrev))
  dimensions.columnWidth.watch(height => {
    const top = height / 2
    btnPrev.css({top}),
    btnNext.css({top})
  });
}

const initHighlight = container => {
  const highlight = new Observable([])
  const buttons = container.find('.extreme-matrix-controls .button[data-name]')
  const rows = container.find('tr[data-name]')
  highlight.watch(highlight => {
    buttons.each(function () {
      const name = $(this).data('name')
      $(this)
        .toggleClass('button--cta', highlight.includes(name))
        .toggleClass('button--sec', !highlight.includes(name))
    })
    rows.each(function () {
      const name = $(this).data('name')
      $(this).toggleClass('xr-highlight', highlight.includes(name))
    })
  })

  buttons.click(function () {
    const name = $(this).data('name')
    const hl = highlight.get()
    if (hl.includes(name)) {
      highlight.set(hl.filter(x => x !== name))
    } else {
      highlight.set(hl.concat(name))
    }
  })
}

const init = container => {
  container.find('th, td').addClass('no-padding').wrapInner('<span />')
  const dimensions = initDimensions(container)
  initHeader(container)
  const { columnCount, resetColumns, canReset } = initClose(container, dimensions)
  const resetbtn = container.find('.xr-reset').click(resetColumns)
  canReset.watch(canReset => resetbtn.toggleClass('xr-hidden', !canReset))
  const scroll = initScroll(container, dimensions, columnCount)
  addButtons(container.find('.container'), scroll, dimensions)
  initHighlight(container)
  refreshBcrs()
}

jQuery($ => { 
  $('.extreme-matrix').each(function () {
    init($(this))
  })
})